import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
// build Wed Apr  8 12:52:27 EDT 2026
// build2 Wed Apr  8 12:53:54 EDT 2026
